/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const productPreviewNodes = document.querySelectorAll('.product-preview');

if (productPreviewNodes.length > 0) {
    import(/* webpackChunkName: "ProductPreview" */ './components/ProductPreview').then(({default: ProductPreview}) => {
        [...productPreviewNodes].forEach((node) => render(<ProductPreview {...parseDataToProps(node.dataset)} />, node));
    });
}
